import { createFileRoute } from '@tanstack/react-router'
import { TerminalConnectTestPage } from '@terminalConnect/testHarness/TerminalConnectTestPage'

export const Route = createFileRoute('/_auth/terminal-connect/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <TerminalConnectTestPage />
}
